export default "__VITE_ASSET__CLBtW$jj__"